import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

export default function HubungiPenjual({ isOpen, onClose, data }) {
  console.log(data);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Kontak PIC</ModalHeader>
        <ModalCloseButton />
        <hr />
        <ModalBody>
          <Stack spacing={2}>
            <Box>
              <Text fontWeight="500" fontSize="14px" color="#B9B9B9">
                Email Perusahaan
              </Text>
              <Text fontWeight="500" fontSize="16px">
                {data?.email}
              </Text>
            </Box>
            <Box>
              <Text fontWeight="500" fontSize="14px" color="#B9B9B9">
                No Telp Perusahaan
              </Text>
              <Text fontWeight="500" fontSize="16px">
                {data?.phone}
              </Text>
            </Box>
            <Box>
              <Text fontWeight="500" fontSize="14px" color="#B9B9B9">
                PIC Name
              </Text>
              <Text fontWeight="500" fontSize="16px">
                {data?.pic_name}
              </Text>
            </Box>
            <Box>
              <Text fontWeight="500" fontSize="14px" color="#B9B9B9">
                PIC No Telp
              </Text>
              <Text fontWeight="500" fontSize="16px">
                {data?.pic_phone}
              </Text>
            </Box>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
